<template>
  <span class="nome-sito-piccolo" style="padding: 0;margin: 0">
    <span>Facile Check</span>
    <span style="padding-top: 10px; font-size: 14px">-</span>
    <span>in</span>
  </span>
</template>

<script>
export default {
  name: "NomeSitoPiccolo",
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nome-sito-piccolo {
  font-family: "Poiret One", cursive;
  font-size: 24px;
  color: #28a745;
  font-weight: 700;
}
</style>
